import React from 'react';
import apiRequest, { getApiBaseUrl } from './admin/services/apiClient';

const SiteSettingsContext = React.createContext(null);

export const getCoupleInitials = (coupleNames) => {
  const value = String(coupleNames || '').trim();
  const names = value.split(/\s*(?:&|and|et)\s*/i).map((name) => name.trim()).filter(Boolean);
  const parts = names.length >= 2 ? names : value.split(/\s+/).filter(Boolean);
  const first = parts[0] ? parts[0].charAt(0).toUpperCase() : 'A';
  const second = parts[1] ? parts[1].charAt(0).toUpperCase() : 'M';
  return `${first} & ${second}`;
};

export const createBrandIconDataUrl = (coupleNames) => {
  const svgInitials = getCoupleInitials(coupleNames).replace(/&/g, '&amp;');
  const fontUrl = `${window.location.origin}/fonts/GreatVibes-Regular.woff2`;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><style>@font-face{font-family:'Great Vibes';font-style:normal;font-weight:400;src:url('${fontUrl}') format('woff2');}</style><rect width="512" height="512" rx="116" fill="#8fbfd1"/><text x="256" y="315" text-anchor="middle" fill="#fff" font-family="'Great Vibes', cursive" font-size="126">${svgInitials}</text></svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

const updateBrandIcons = (coupleNames) => {
  const iconUrl = createBrandIconDataUrl(coupleNames);
  document.querySelectorAll('[data-brand-icon]').forEach((link) => link.setAttribute('href', iconUrl));
};

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = React.useState(null);

  React.useEffect(() => {
    apiRequest('/site-settings.php')
      .then((response) => {
        const data = response.data || {};
        setSettings(data);
        document.title = data.siteTitle || '';
        updateBrandIcons(data.coupleNames);
      })
      .catch(() => setSettings({}));
  }, []);

  return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
};

export const useSiteSettings = () => React.useContext(SiteSettingsContext) || {};

export const resolveMediaUrl = (value) => {
  if (!value) return '';
  try {
    const url = new URL(value, window.location.origin);
    if (url.pathname.indexOf('/uploads/') === 0) {
      const apiUrl = new URL(getApiBaseUrl(), window.location.origin);
      const apiRoot = apiUrl.pathname.replace(/\/api\/?$/, '').replace(/\/$/, '');
      return `${apiUrl.origin}${apiRoot}${url.pathname}${url.search}`;
    }
    return url.toString();
  } catch (error) {
    return value;
  }
};
